// noinspection JSUnusedGlobalSymbols
export enum OrganizationType {
  GENERAL_AGENCY = 'GENERAL_AGENCY',
  CARRIER = 'CARRIER',
  RETAILER = 'RETAILER',
  INTEGRATION = 'INTEGRATION'
}
